import Barba from '@barba/core'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import dt from 'datatables.net'


import pageTransitionTest from './barba/pageTransitionTest'



import readPageColours from './colours/readPageColours'
import readSingleColour from './colours/readSingleColour'
import { calculateWidth, calculateImageOrientation } from './functions/functions'


import handlePopup from './feedback/pop-up'

const mainTag = document.querySelector('main')
gsap.registerPlugin(ScrollTrigger);


const table = document.querySelector('#index_of_artworks')
if (table) {
    let dataTable = new dt(table, {
        recordsTotal: 500,
        paging: false
    })
}




    // ** MENU ( Wrap in a function for use on every page )
function initMenu() {
    const menuTrigger = document.querySelector('.burger-menu')
    const closeButton = document.querySelector('.close-button')
    const menu = document.querySelector('.menu-container')
    menuTrigger.addEventListener('click', () => {
        menu.classList.add('menu-open')
    })
    closeButton.addEventListener('click', () => {
        menu.classList.remove('menu-open')
    })
}



if (window.location.href.indexOf("exhibit") > -1) {

    const exhibitHeader = document.querySelector('.exhibit-header')
    const exhibitTitle = document.querySelector('.exhibit-header .title')
    const exhibitImages = document.querySelectorAll('.exhibit-header .image img')


    initMenu()

    let tl = gsap.timeline({
        scrollTrigger: {
            trigger: exhibitHeader,
            // markers: true,
            start: 'top top',
            end: '50% 90%', 
            scrub: 1,
            ease: 'linear'
        }
    })

    tl.to(exhibitTitle, {
        opacity: 0,
        scale: 0.9,
        
    }, 1)
    


    exhibitImages.forEach(exhibitImage => {
        if(exhibitImage.width > exhibitImage.height) {
            exhibitImage.classList.add('landscape')
        } else {
            exhibitImage.classList.add('portrait')
        }
        if (exhibitImages.length < 2) {
            tl.to(exhibitImage, {
                scale: 1.1,
            }, 1)
        }
        
    })
   

   

    //* Header Fade
    const header = document.querySelector('.exhibit-header')

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if(entry.intersectionRatio >= 0.4) {
                mainTag.classList.remove('content-visible')
            } else {
                mainTag.classList.add('content-visible')
            }
        })

    }, {
        threshold: [0, 0.4, 1],
    })

    observer.observe(header)



    //* PROGRESS BAR
    const progressInner = document.querySelector('.progress-inner')

    function calculatePercentage() {
        let scrollTop = window.scrollY
        let docHeight = document.body.offsetHeight
        let winHeight = window.innerHeight
        let scrollPercent = scrollTop / (docHeight - winHeight)
        // let scrollPercentRounded = Math.round(scrollPercent * 100)
        progressInner.style.width = ( scrollPercent * 100 ) + "%"
    }

    window.addEventListener('scroll', () => {
        calculatePercentage();
    })


    //* NAVIGATION START
    const exhibitNavigation = document.querySelector('.exhibit-navigation')
    //! rudimentary as we would need to dynamically load these
    const links = document.querySelectorAll('.navigation-link')
    const nextExhibit = document.querySelector('.next-exhibit')
    const previousExhibit = document.querySelector('.previous-exhibit')

    links.forEach(link => {
        link.addEventListener('mouseenter', () => {
            if (link.classList.contains('next')) {
                const color = nextExhibit.getAttribute('data-color')
                nextExhibit.classList.add('visible')
                exhibitNavigation.style.backgroundColor = color
            } else if (link.classList.contains('previous')) {
                const color = previousExhibit.getAttribute('data-color')
                previousExhibit.classList.add('visible')
                exhibitNavigation.style.backgroundColor = color
            }
           
        })
        link.addEventListener('mouseleave', () => {
            nextExhibit.classList.remove('visible')
            previousExhibit.classList.remove('visible')
            exhibitNavigation.style.backgroundColor = 'unset'
        })
    })
  


    //* LIGHTBOXES
   
    const lightbox = document.querySelector('.lightbox')
    const lightboxImages = document.querySelectorAll('.lightbox-image')
    const lightboxImage = lightbox.querySelector('figure img')
    const lightboxCaption = lightbox.querySelector('.caption')
    const lightboxOverlay = lightbox.querySelector('.background-overlay')
    const lightboxClose = lightbox.querySelector('.close-button')

    lightboxClose.addEventListener('click', () => {
        lightbox.classList.remove('visible')
        
    })
    lightboxOverlay.addEventListener('click', () => {
        lightbox.classList.remove('visible')
        
    })

    lightboxImages.forEach(image => {
        image.addEventListener('click', () => {
            lightboxImage.setAttribute('src', '')
            lightboxCaption.innerHTML = ''
            const src = image.getAttribute('src')
            const alt = image.getAttribute('alt')
            
            lightboxCaption.innerHTML = alt
            lightboxImage.setAttribute('src', src)
            lightboxImage.setAttribute('alt', alt)

            lightbox.classList.add('visible')

        })
    })

    const mainImgs = document.querySelectorAll('.exhibit-header img')
    const paintingFab = document.querySelector('.painting')
    console.log(mainImgs)

    paintingFab.addEventListener('click', () => {
        mainImgs.forEach(img => {
            lightboxImage.setAttribute('src', '')
            lightboxCaption.innerHTML = ''
            const src = img.getAttribute('src')
            const alt = img.getAttribute('alt')

            lightboxCaption.innerHTML = alt
            lightboxImage.setAttribute('src', src)
            lightboxImage.setAttribute('alt', alt)

            lightbox.classList.add('visible')
        })
    })



    //* FREE PAN SECTION

    const freePanSections = document.querySelectorAll('.free-pan div')

    freePanSections.forEach(freePanSection => {
        freePanSection.addEventListener('click', () => {

            const freePanImage = freePanSection.querySelector('img.small-image')
            const toast = freePanSection.querySelector('.toast')
    
            toast.style.display = 'none'
    
            function handleZoom(e) {
                freePanImage.style.transform = 'scale(2)'
                const x = ((e.clientX - this.getBoundingClientRect().left) / this.getBoundingClientRect().width) * 100
                const y = ((e.clientY - this.getBoundingClientRect().top) / this.getBoundingClientRect().height) * 100
                freePanImage.style.transformOrigin = `${x}% ${y}%`
            }
          
            freePanSection.addEventListener('mouseleave', () => {
                freePanImage.style.transform = 'scale(1)'
                freePanSection.removeEventListener('mousemove', handleZoom)
                toast.style.display = 'inline-block'
            })
        
            freePanSection.addEventListener('mousemove', handleZoom)
        })
    })

   
    



    //* HOTSPOTS


    // TODOs 
        // * Responsive Pullquotes 
        // * Split out Aquisition details and Previous Owners
        // * Date and medium not in italics
        // * Eliminate Tombstone as an optional layout - everything to be single overview OR Double entry
        // * Remove Medium and have artist and date on same line - Artist, Date
        // * Narrow up Double entry slightly
        // * Zurbaran Trust copyright -> Durham University
        // * Back to Start Button gallery navigation
        // * Re-look at gallery introduction as its not super impactful,
        // * Responsive Gallery 
        // * Responsive Exhibition
        // * Responsive header on Exhibit
        // * FAB Buttons -- could be quite an important one to get before tomorrow even if they dont work
        // * What is going to be in my menu
        // * in menu we could include an index of galleries on this page
        // * include a counter on the galleries to help with navigation
        // * double check bibliography
        // * Menu Exhibit index galleries and exhibits
        // * Double entry header
        // * painting details!!
        // * Lightboxes
        // * Gallery and Exhibit Navigation Loop
        // * Exhibition Navigation Styles
        // * Double entry exhibit thumbnail?
        // * Fab Favourite/thumbsup/down and painting
        // * Homepage link?
        // * Homepage start
        // * Standard page style - base heavily on exhibit for T&C's etc and form - nothing too fancy
        // * --colophon, priv policy, T&Cs, etc
        // * Homepage / Landing Page - basic format at first with gloss later. 
        // * Get Fab painting button working
        // * Free Pan Click Trigger
        // * Consistency with Colours - Ajax to set colour field on post :S
        // * Choose Gallery Crop
        // * Start filling out real copy
        // * Organise files and collect painting assets
        // * Previous owners to be a single wysiwyg instead of a repeater
        // * same with Bibliography
        // * Combine Acq details and previous owners to painting details box
        // * move Bibliography to bottom
        // * Add authors to exhibits ( Italics )
        // * Institution in Tombstones
        // * hook into back to start link to reset gallery colour 
        // * Menu Word Wrapping
        // * Menu for Exhibition and home/standard pages?
        // * Change box-shadows to a filter: drop-shadow();
        // * Check Artwork Details for full stops and capitals
        // * Institutions - Crop logo images
        // * Exhibit titles - in menu in italics but not connectors ( e.g. & )
        // * Institution to link through to external website
        // * Running Header Font Sizes
        // ? Mobile Menu Trigger
        // ? Add Free Pan Sections to Exhibits
        // * Double Entry Free Pans ( Side by Side individually Actionable )
        // * Replace feedback footer with sign up to newsletter

        
        // ! Favourites trigger free text form
        // ! Form Styles
       

        // ! Collecting Feedback 
        // ! Collecting favourites
        // ! Feedback Form
        // ! Form Redirect
        
        
        // ! FAB Painting Lightbox carousel for double entries
        // ! Double entry Fab Painting Lightbox... Carousel? or 2 up?


        // ! Check Exhibit Styles with artwork - in particular titles and the header section!!
        // ! Check Gallery Styles now artworks are in

        // ! Add Light colour control to text
        // ! Ability to turn colour changing on or off
        
       
        // ! Hotspots
        // ! double entry hotspots 
       

        // ! Index of Artworks
        // ! basic tag styles for generic pages


        // !!! Need to check on a mobile! - not loads of tweaks but some font sizing issues.
        // ! Firefox scrolling issues on desktop

        // Tomorrow
        
        // ! Talked about possible last 'next post prompting next gallery'
        // ! Last gallery display an advert for the book?
        // ? Got this half set up...

        
        // ! Section entrance animations - start with a simple fade observer - Exhibit Primarily
        // ! Page Transitions - would need to test animations first...
        // ! Code Clean up!!
            
        // ! Masonary Grid of artworks on home
        // ! for FAB buttons we want to include toasts - take a look at toast libries
        // ! Possibly a .org address


} else if (window.location.href.indexOf("gallery") > -1) {
    
    // calculateWidth()
    calculateImageOrientation('.single-exhibit-overview .image')
    readSingleColour()
    readPageColours()


    //! Trigger Running Header
    const firstPanel = document.querySelector('.gallery-introduction')
    const runningHeader = document.querySelector('.running-header')
    
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if ( entry.intersectionRatio < 0.5 ) {
                runningHeader.classList.add('visible')
            } else {
                runningHeader.classList.remove('visible') 
            }
        })
    }, {
        threshold: [0, 0.5 , 1],
    })

    observer.observe(firstPanel)

    
    initMenu()


        // Back to start hook

        const startLink = document.querySelector('a.start-link')
        console.log(startLink)
    
        startLink.addEventListener('click', function(e) {
            e.preventDefault()
            readSingleColour()
            window.location = this.href
            console.log(e)
        })
    
    

} else if ((window.location.href.indexOf("spanish-art-in-county-durham") > -1) ) {

    calculateWidth()
    calculateImageOrientation('.single-exhibit-overview .image')
    readPageColours()

    handlePopup('#demographics')

        
    // ! REFRESHED OBSERVER FOR HOZ SCROLL - to add colour change once that has been finalised
    
    const galleryCounter = document.querySelector('.gallery-counter')
    const exhibitionContent = document.querySelector('.exhibition-content')
    const galleries = document.querySelectorAll('.gallery-section')

    const observer = new IntersectionObserver((entries) => {
        const current = galleryCounter.querySelector('.current')
        entries.forEach((entry) => {
            const index = entry.target.getAttribute('data-index')
            if ( entry.intersectionRatio > 0.5 && entry.target.classList.contains('gallery-section')) {
               current.innerHTML = index
               galleryCounter.classList.add('visible')
            }
            if ( entry.intersectionRatio > 0.5 && entry.target.classList.contains('exhibition-content')) {
                galleryCounter.classList.remove('visible')
            }
        })
    }, {
        threshold: [0, 0.5, 1],
    })
    
    observer.observe(exhibitionContent)
    galleries.forEach((gallery, i) => {
        gallery.setAttribute('data-index', i + 1)
        observer.observe(gallery)
    })

    initMenu()


} else {

    initMenu()

     
    


}





